/**
 * Build the OnlyFans tracking URL for metrics returned by
 * GET /api/metrics/:userId/campaignsAndTrialsNamesAndIds
 * (see SextforceMetricsCampaignOverview / campaign create dialog).
 */
export type MetricTrackingRow = {
    type: string;
    payload?: {
        name?: string;
        createdAt?: Date;
        campaignCode?: number;
        url?: string;
    };
};

const normalizeUrl = (u: string): string => u.trim().replace(/\/$/, '');

export const buildMetricTrackingUrl = (metric: MetricTrackingRow, onlyfansUsername: string): string => {
    if (metric.type === 'promoCampaign') {
        const code = metric.payload?.campaignCode;
        if (code != null && Number.isFinite(Number(code))) {
            return `https://onlyfans.com/${onlyfansUsername}/c${code}`;
        }
        return metric.payload?.url?.trim() || '';
    }
    if (metric.type === 'trialLinkTrial') {
        // Free trial links look like this: https://onlyfans.com/chloemaefree/trial/jy9dgk62vn7pfvxdixfi8bfspq66jpna
        // Usernames change so we need to extral the token from the URL and use it to build the URL with the current username
        const token = metric.payload?.url?.split('/').pop();

        if (!token) {
            return '';
        }
        return `https://onlyfans.com/${onlyfansUsername}/trial/${token}`;
    }
    return '';
};

export const findMetricIdForSavedTrackingLink = (
    metrics: Array<MetricTrackingRow & { _id: string }>,
    onlyfansUsername: string,
    savedUrl: string | null | undefined,
): string | null => {
    if (!savedUrl?.trim() || !onlyfansUsername) {
        return null;
    }
    const target = normalizeUrl(savedUrl);
    for (const m of metrics) {
        const built = buildMetricTrackingUrl(m, onlyfansUsername);
        if (built && normalizeUrl(built) === target) {
            return String(m._id);
        }
    }
    return null;
};
